export const PRESET_EMERGENCIAS = [
  {
    titulo: "Aviso de incendio",
    icon: "🔥",
    texto:
      "Hay un incendio activo en su zona. Manténgase alejado del área y siga las indicaciones de los servicios de emergencia.",
  },
  {
    titulo: "Evacuación preventiva",
    icon: "🚨",
    texto:
      "Se recomienda evacuación preventiva de su zona por riesgo de incendio. Siga las rutas indicadas por los servicios de emergencia.",
  },
  {
    titulo: "Precaución — humo en la zona",
    icon: "🌫️",
    texto:
      "Hay humo en su área. Cierre puertas y ventanas y permanezca en el interior hasta nuevo aviso.",
  },
  {
    titulo: "Fin de alerta",
    icon: "✅",
    texto:
      "La alerta en su zona ha finalizado. Puede retornar a su domicilio con precaución.",
  },
];

export const PRESET_PREEMERGENCIAS = [
  {
    titulo: "Previfoc 2",
    categoria: "Previfoc",
    icon: "🔥",
    nivel: "importante",
    texto:
      "El municipio se encuentra en nivel Previfoc 2 de peligro alto de incendio forestal. Extremen las precauciones y eviten actividades de riesgo al aire libre.",
  },
  {
    titulo: "Previfoc 3",
    categoria: "Previfoc",
    icon: "🔥",
    nivel: "extraordinario",
    texto:
      "El municipio se encuentra en nivel Previfoc 3 de peligro extremo de incendio forestal. Extremen las precauciones y eviten actividades de riesgo al aire libre.",
  },
  {
    titulo: "Lluvias",
    categoria: "Lluvias",
    icon: "🌧️",
    nivel: "importante",
    texto:
      "Se prevén lluvias de intensidad importante en el municipio. Eviten zonas inundables y extremen las precauciones en sus desplazamientos.",
  },
  {
    titulo: "Lluvias",
    categoria: "Lluvias",
    icon: "🌧️",
    nivel: "extraordinario",
    texto:
      "Se prevén lluvias torrenciales de carácter extraordinario en el municipio. Eviten desplazamientos innecesarios y manténganse alejados de cauces, barrancos y zonas inundables.",
  },
  {
    titulo: "Vientos",
    categoria: "Vientos",
    icon: "💨",
    nivel: "importante",
    texto:
      "Se prevén vientos fuertes de intensidad importante en el municipio. Extremen las precauciones, especialmente en zonas elevadas y al circular por carretera.",
  },
  {
    titulo: "Vientos",
    categoria: "Vientos",
    icon: "💨",
    nivel: "extraordinario",
    texto:
      "Se prevén vientos muy fuertes de carácter extraordinario en el municipio. Eviten desplazamientos innecesarios, aléjense de árboles y estructuras inestables, y aseguren objetos que puedan desprenderse.",
  },
  {
    titulo: "Tormentas",
    categoria: "Tormentas",
    icon: "⛈️",
    nivel: "importante",
    texto:
      "Se prevén tormentas de intensidad importante en el municipio, con posibilidad de aparato eléctrico. Busquen refugio en interiores y eviten zonas abiertas y elevadas.",
  },
  {
    titulo: "Tormentas",
    categoria: "Tormentas",
    icon: "⛈️",
    nivel: "extraordinario",
    texto:
      "Se prevén tormentas severas de carácter extraordinario en el municipio, con riesgo de granizo y fuertes rachas de viento. Permanezcan en el interior y aléjense de ventanas.",
  },
  {
    titulo: "Temperaturas altas",
    categoria: "Temperaturas altas",
    icon: "🌡️",
    nivel: "importante",
    texto:
      "Se prevén temperaturas elevadas de nivel importante en el municipio. Eviten la exposición al sol en las horas centrales del día y manténganse hidratados.",
  },
  {
    titulo: "Temperaturas altas",
    categoria: "Temperaturas altas",
    icon: "🌡️",
    nivel: "extraordinario",
    texto:
      "Se prevén temperaturas extremadamente altas en el municipio. Eviten cualquier actividad al aire libre en las horas centrales del día, hidrátense con frecuencia y extremen la precaución con personas vulnerables.",
  },
  {
    titulo: "Temperaturas bajas",
    categoria: "Temperaturas bajas",
    icon: "❄️",
    nivel: "importante",
    texto:
      "Se prevén temperaturas bajas de nivel importante en el municipio. Abríguense adecuadamente y extremen la precaución ante posibles placas de hielo.",
  },
  {
    titulo: "Temperaturas bajas",
    categoria: "Temperaturas bajas",
    icon: "❄️",
    nivel: "extraordinario",
    texto:
      "Se prevén temperaturas extremadamente bajas en el municipio. Eviten desplazamientos innecesarios, abríguense adecuadamente y extremen la precaución con personas vulnerables.",
  },
  {
    titulo: "Inundación",
    categoria: "Inundación",
    icon: "🌊",
    nivel: "importante",
    texto:
      "Riesgo importante de inundación en el municipio. Eviten zonas bajas, cauces y aparcamientos subterráneos.",
  },
  {
    titulo: "Inundación",
    categoria: "Inundación",
    icon: "🌊",
    nivel: "extraordinario",
    texto:
      "Riesgo extraordinario de inundación en el municipio. Aléjense de cauces, barrancos y zonas bajas, y sigan las indicaciones de los servicios de emergencia.",
  },
];

export const NIVEL_COLOR = {
  importante: "#f59e0b",
  extraordinario: "#dc2626",
};

// Equivalente en emoji del color de NIVEL_COLOR, para poder incluirlo en el
// texto plano de la notificación (que no admite colores reales).
export const NIVEL_CIRCLE = {
  importante: "🟠",
  extraordinario: "🔴",
};

// Etiqueta combinando icono + círculo de color + título, usada tanto en la
// UI como en el titulo/texto que se envía realmente en la notificación.
export const presetLabel = (p) =>
  [p.icon, p.nivel && NIVEL_CIRCLE[p.nivel], p.titulo].filter(Boolean).join(" ");
